module.exports = __webpack_public_path__ + "img/personnel_access_feature_03.f39153d1.jpg";